module.exports = __webpack_public_path__ + "img/banner_error_with_undo.5dc240b6.webp";